import DialogContentText from '@mui/material/DialogContentText';

export { DialogContentText };
